import Action from './action';
import { equar } from '../../../utils/common';
export interface ILoginAddress {
    id: number, 
    name: string
}

export interface ILoginAddressState {
    loginAddress: ILoginAddress[],
    errorTexts: string[],
}

const initialState = {
    loginAddress: [],
    errorTexts: []
};

export default (state: ILoginAddressState = initialState, action: {type: string, playload: ILoginAddress | number | string[]}) => {
    switch (action.type) {
        case Action.UPDATE_LOGIN_ADDRESS: {
            return {
                ...state,
                loginAddress: action.playload
            }
        }
        case Action.UPDATE_LOGIN_ADDRESS_ERROR: {
            try {
                const newErrors = (action.playload as string[] || []).filter(Boolean);
                const curErrors = state.errorTexts.filter(Boolean);
                if (!equar(newErrors, curErrors) && newErrors.length >= curErrors.length) {
                    (window as any).mailStats.show('login_address_error', { errorText: action.playload })
                }
            } catch(e) {}
            return {
                ...state,
                errorTexts: action.playload
            }
        }
        case Action.UPDATE_LOGIN_ADDRESS_ERROR_BY_INDEX: {
            state.errorTexts.splice(action.playload as number, 1)
            return {
                ...state,
                errorTexts: [...state.errorTexts]
            }
        }
        default: return state;
    }
}
